export default {"src":"https://images-cdn.curipod.com/d-144eea2a/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};